















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { Culture } from '@/dto';
import { UserState, CultureState } from '@/store';

@Component
export default class CultureComponent extends Vue {
    public cultures: Culture[] = [];

    public changeCulture(culture: Culture) {
        UserState.changeCulture(culture);
    }

    public isSelectedCulture(culture: Culture): boolean {
        let result;

        const currentCulture = CultureState.currentCulture;
        if (currentCulture) {
            result = currentCulture.localName === culture.localName;
        } else {
            result = false;
        }

        return result;
    }

    public async created(): Promise<void> {
        this.cultures = CultureState.cultures;
    }
}
